import { ref } from 'vue';

const useComposable = (emits) => {
  const refs = {
    day: ref(-1),
    days: ref([]),
    year: ref(-1),
    month: ref(-1),
    realityDate: ref()
    //* 真实日期
  };
  const variable = {
    disabled: void 0
  };
  const methods = {
    //* 切换选择器组件
    changeComponent: (mode) => emits("update", mode, {}),
    //* 切换时间
    changeDate: (date) => emits("update", "date", date),
    //* 选择日期
    changeDay: (date) => {
      if (!(variable.disabled && variable.disabled(/* @__PURE__ */ new Date(`${date.year}-${date.month + 1}-${date.day}`)))) {
        emits("change", date);
      }
    }
  };
  const disposes = {
    //* 初始化函数
    init: (data, disabled) => {
      refs.day.value = data.date.getDate();
      refs.year.value = data.date.getFullYear();
      refs.month.value = data.date.getMonth();
      refs.realityDate.value = data.realityDate;
      variable.disabled = disabled;
      refs.days.value = [];
      const dateNext = disposes.receiveStartDate(new Date(data.date.getFullYear(), data.date.getMonth()));
      for (let i = 0; i < 42; i++) {
        const current = new Date(dateNext.getFullYear(), dateNext.getMonth(), dateNext.getDate() + i);
        refs.days.value.push({
          day: current.getDate(),
          year: current.getFullYear(),
          month: current.getMonth()
        });
      }
    },
    //* 获取开始的日期对象
    receiveStartDate: (date) => {
      let day = date.getDay();
      if (day == 0) day = 7;
      else if (day == 1) {
        return date;
      }
      return new Date(date.getFullYear(), date.getMonth(), (day - 2) * -1);
    },
    //* 获取当前日期的className
    receiveDayClassName: (year, month, day) => {
      var _a, _b, _c;
      return {
        "ui-disabled-status": variable.disabled && variable.disabled(/* @__PURE__ */ new Date(`${year}-${month + 1}-${day}`)),
        "ui-readonly-status": refs.month.value != month,
        "ui-active": ((_a = refs.realityDate.value) == null ? void 0 : _a.getDate()) == day && ((_b = refs.realityDate.value) == null ? void 0 : _b.getFullYear()) == year && ((_c = refs.realityDate.value) == null ? void 0 : _c.getMonth()) == month
      };
    }
  };
  return { refs, methods, disposes };
};

export { useComposable };
//# sourceMappingURL=composable.mjs.map
